/**
 * Sắp xếp danh sách size dạng string[]
 * - Quần áo (S, M, L...) trước giày (36, 37.5...)
 */
export function sortSizesFromStrings(sizes: string[]): string[] {
  const isShoeSize = (val: string): boolean =>
    /^(\d+(\.\d+)?)$/.test(val.trim())

  const clothingSizeRank = (size: string): number => {
    const val = size.trim().toUpperCase()

    if (val === 'M') return 0
    if (val === 'X') return -1.5

    const multiXLMatch = val.match(/^(\d+)XL$/)
    if (multiXLMatch) {
      const count = parseInt(multiXLMatch[1], 10)
      return 1 + count
    }

    const match = val.match(/^(X*)(S|L)$/)
    if (!match) return 999
    const [, xPrefix = '', base] = match
    const xCount = xPrefix.length

    if (base === 'S') return -1 - xCount
    if (base === 'L') return 1 + xCount

    return 999
  }

  return [...sizes].sort((a, b) => {
    const aIsShoe = isShoeSize(a)
    const bIsShoe = isShoeSize(b)

    if (!aIsShoe && !bIsShoe) {
      return clothingSizeRank(a) - clothingSizeRank(b)
    }

    if (aIsShoe && bIsShoe) {
      return parseFloat(a) - parseFloat(b)
    }

    return aIsShoe ? 1 : -1
  })
}

/**
 * Sắp xếp danh sách size dạng object[] với key size
 * - Quần áo (S, M, L...) trước giày (36, 37.5...)
 */
export function sortSizesFromObjects<T extends Record<string, unknown>>(
  sizes: T[],
  key: keyof T
): T[] {
  const isShoeSize = (val: string): boolean =>
    /^(\d+(\.\d+)?)$/.test(val.trim())

  const clothingSizeRank = (size: string): number => {
    const val = size.trim().toUpperCase()

    if (val === 'M') return 0
    if (val === 'X') return -1.5

    const multiXLMatch = val.match(/^(\d+)XL$/)
    if (multiXLMatch) {
      const count = parseInt(multiXLMatch[1], 10)
      return 1 + count
    }

    const match = val.match(/^(X*)(S|L)$/)
    if (!match) return 999
    const [, xPrefix = '', base] = match
    const xCount = xPrefix.length

    if (base === 'S') return -1 - xCount
    if (base === 'L') return 1 + xCount

    return 999
  }

  return [...sizes].sort((a, b) => {
    const aVal = String(a[key])
    const bVal = String(b[key])

    const aIsShoe = isShoeSize(aVal)
    const bIsShoe = isShoeSize(bVal)

    if (!aIsShoe && !bIsShoe) {
      return clothingSizeRank(aVal) - clothingSizeRank(bVal)
    }

    if (aIsShoe && bIsShoe) {
      return parseFloat(aVal) - parseFloat(bVal)
    }

    return aIsShoe ? 1 : -1
  })
}
